module.exports = __webpack_public_path__ + "static/media/prizm-field.82ed6ac7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-field.mp4
// module id = 3543
// module chunks = 0